// extracted by mini-css-extract-plugin
module.exports = {"documentLinkContainer":"DocumentLink_documentLinkContainer__2ObYW","fileListContainer":"DocumentLink_fileListContainer__30rPS","fileItem":"DocumentLink_fileItem__2wmRn"};